import classNames from "classnames";
import AppContext from "PFApp/app_context";
import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import Checkbox from "PFComponents/checkbox/checkbox";
import { ApiRoute } from "PFCore/utilities/routes";
import { GROWL_ACTIONS } from "PFReducers/growl_reducer";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./import_users.less";

const NewUserPage = () => {
  const { t } = useTranslation("admin");
  const { dispatch } = useContext(AppContext);
  const [sendEmail, setSendEmail] = useState(false);
  const [forceRegStatus, setForceRegStatus] = useState(false);
  const [firstChangeRequest, setFirstChangeRequest] = useState(false);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState(null);
  const [success, setSuccess] = useState(false);
  const [warning, setWarning] = useState(null);

  const importUsers = () => {
    setWarning(null);
    const attachment = file[0];
    if (!attachment) {
      return;
    }
    const formData = new FormData();
    formData.append("csv", attachment);
    formData.append("options[notify]", sendEmail);
    formData.append("options[force_active_registration_status]", forceRegStatus);
    formData.append("options[change_request_position]", firstChangeRequest);
    $.ajax({
      method: "POST",
      url: ApiRoute(`/api/admin/imports/users`),
      api_version: 2,
      processData: false,
      contentType: false,
      data: formData
    })
      .then((res) => {
        // processing_started;
        dispatch({
          type: GROWL_ACTIONS.GROWL_RENDER,
          payload: {
            message: t("user.import.processingStarted"),
            kind: "success"
          }
        });
        setTimeout(() => {
          $.ajax({
            url: ApiRoute(`/api/imports/${res.id}`),
            api_version: 2
          }).then((resp) => {
            if (resp?.errors?.length > 0 || resp?.warnings.length > 0) {
              setSuccess(false);
              setWarning(resp?.warnings);
              dispatch({
                type: GROWL_ACTIONS.GROWL_RENDER,
                payload: {
                  message: t("user.import.processingFail"),
                  kind: "error"
                }
              });
            } else {
              setErrors(null);
              setWarning(null);
              setSuccess(true);
              dispatch({
                type: GROWL_ACTIONS.GROWL_RENDER,
                payload: {
                  title: t("user.import.processingSuccessTitle"),
                  message: t("user.import.processingSuccess"),
                  kind: "success"
                }
              });
            }
          });
        }, 2000);
      })
      .catch((err) => {
        setErrors(err?.responseJSON?.errors?.[0]);
      });
  };

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false);
      }, 8000);
    }
  }, [success]);

  return (
    <div>
      <h1 className={css.header}>{t("user.import.title")}</h1>
      <PageBox style={{ padding: 20, maxWidth: 900 }}>
        {errors && (
          <div className={css.errorBox}>
            <div className={css.errorTitle}>Your CSV file has not been saved </div>
            <div>{`General: ${errors?.[0] || errors || "something went wrong"} `}</div>
          </div>
        )}
        {success && (
          <div className={css.successBox}>
            Your file is now being processed, this might take a few minutes.
          </div>
        )}
        {warning && (
          <div className={css.warningBox}>
            <div>{t("user.import.warningsTitle")}</div>
            {warning?.map((item, index) => {
              const keys = Object.keys(item);
              const warningKeys = keys.filter((item) => item !== "row");
              return (
                <>
                  <h3>{`Row #${item?.row}:`}</h3>
                  <div key={index} className={css.warningText}>
                    {warningKeys.map((key) => (
                      <>
                        <div>{`${key}: ${item?.[key]}`}</div>
                      </>
                    ))}
                  </div>
                  <br />
                </>
              );
            })}
          </div>
        )}
        <div className={css.lineWrapper}>
          <div className={css.left}>{t("user.import.csvFile")}</div>
          <div className={css.right}>
            <div className={css.inputWrapper}>
              <label htmlFor="upload" className={css.filesLabel}>
                <Button kind="secondary" tag="a" handleChange={() => {}}>
                  Choose a CSV file...
                </Button>
              </label>
              <input
                id="upload"
                type="file"
                style={{ display: "none" }}
                multiple={false}
                onChange={(e) => setFile(e?.target?.files)}
              />
              {file && <div className={css.fileName}>{file?.[0].name}</div>}
            </div>
          </div>
        </div>
        <div className={css.lineWrapper}>
          <div className={css.left}>{t("user.import.sendWelcomeEmailsLabel")}</div>
          <div className={css.right}>
            <Checkbox checked={sendEmail} handleChange={setSendEmail} />
          </div>
        </div>
        <div className={css.lineWrapper}>
          <div className={css.left}>{t("user.import.forceActiveRegistrationStatus")}</div>
          <div className={css.right}>
            <Checkbox checked={forceRegStatus} handleChange={setForceRegStatus} />
          </div>
        </div>
        <div className={css.lineWrapper}>
          <div className={classNames(css.left, css.twoLines)}>
            <div>{t("user.import.changeRequestPositionFirst")}</div>
            <div className={css.subTitle}>
              When registering this information will be presented on the 3rd step before other CV suggested
              updates
            </div>
          </div>
          <div className={css.right}>
            <Checkbox checked={firstChangeRequest} handleChange={setFirstChangeRequest} />
          </div>
        </div>
        <div className={css.buttons}>
          <ButtonLink kind="secondary" href="/admin/users">
            Cancel
          </ButtonLink>
          <Button kind="primary" onClick={importUsers} disabled={!file}>
            Send
          </Button>
        </div>
      </PageBox>
    </div>
  );
};

export default NewUserPage;
